import {TruVuFrame} from '../../../lib/truvu/types';
import {hasWebCodec} from './hasWebCodec';

function clearVideoFrames(
  store: Array<{
    frameInClusterId: number;
    frame: TruVuFrame;
    clusterCount: number;
  }>
) {
  if (store.length > 0) {
    if (hasWebCodec()) {
      window.scrollTo({top: 0});

      store.forEach(({frame}) => {
        // Handle TruVu frames with blob URLs
        if ('blobUrl' in frame && frame.blobUrl) {
          // Revoke blob URLs to prevent memory leaks
          URL.revokeObjectURL(frame.blobUrl);
        }
        // Handle WebCodec VideoFrames
        // eslint-disable-next-line
        // @ts-ignore
        else if ('close' in frame && typeof frame.close === 'function') {
          // eslint-disable-next-line
          // @ts-ignore
          frame.close();
        }
      });
    } else {
      // For non-WebCodec environments, still clean up blob URLs
      store.forEach(({frame}) => {
        if ('blobUrl' in frame && frame.blobUrl) {
          URL.revokeObjectURL(frame.blobUrl);
        }
      });
    }
  }
}

export async function terminateExistingWorker(
  worker: Worker | null,
  store: Array<{
    frameInClusterId: number;
    frame: TruVuFrame;
    clusterCount: number;
  }>
) {
  if (worker) {
    await worker.terminate();
  }
  // TODO if we clear frames here, then we need to move the current scroll position cos it is not displaying anything then
  clearVideoFrames(store);
}
